module.exports = "https://static.zego.com/_next/static/images/Mitochondria-c828cddf620ccf1e02fdbd9a38d55ce6.svg";